module.exports = __webpack_public_path__ + "images/thick-element.png?cc7103aa219e760b6870a17edceb787f";